import { Middleware } from '@nuxt/types';

const middleware: Middleware = ({ store }) => {
  store.dispatch('income/fetch');
};

export default middleware;
